import { z } from 'zod'

import {
  dateTimeFilterSchema,
  nullFilterSchema,
  numberFilterSchema,
  stringFilterSchema,
  stringInFilterSchema,
} from './base_filters'

// Nullable文字列フィルタ: 有無（isNull）と部分一致（contains）の両方に対応
const nullableStringFilterSchema = z.object({
  isNull: nullFilterSchema.shape.isNull,
  contains: stringFilterSchema.shape.contains,
})

// TODO: steel系も一緒に扱うか微妙
export const millsheetsFilterSchema = z.object({
  manufacturerName: stringInFilterSchema.optional(),
  issuedDate: dateTimeFilterSchema.optional(),
  no: stringFilterSchema.optional(),
  steelTypes: stringFilterSchema.optional(),
  sizes: stringFilterSchema.optional(),
  totalWeight: numberFilterSchema.optional(),
  status: stringInFilterSchema.optional(),
  buildingPart: stringInFilterSchema.optional(),
  submissionDate: stringInFilterSchema.optional(),
  steelHeatNumber: stringFilterSchema.optional(),
  steelSteelType: stringInFilterSchema.optional(),
  steelSize: stringFilterSchema.optional(),
  steelSteelQuantity: numberFilterSchema.optional(),
  steelWeight: numberFilterSchema.optional(),
  deliveryDestination: stringFilterSchema.optional(),
  notificationNo: nullableStringFilterSchema.optional(),
})
export type MillsheetsFilter = z.infer<typeof millsheetsFilterSchema>

const sorterDirectionSchema = z.enum(['asc', 'desc'])
export const millsheetsSorterSchema = z.union([
  z.object({ manufacturerName: sorterDirectionSchema }),
  z.object({ issuedDate: sorterDirectionSchema }),
  z.object({ no: sorterDirectionSchema }),
  z.object({ steelTypes: sorterDirectionSchema }),
  z.object({ sizes: sorterDirectionSchema }),
  z.object({ totalWeight: sorterDirectionSchema }),
  z.object({ status: sorterDirectionSchema }),
  z.object({ steelHeatNumber: sorterDirectionSchema }),
  z.object({ steelSteelType: sorterDirectionSchema }),
  z.object({ steelSize: sorterDirectionSchema }),
  z.object({ steelSteelQuantity: sorterDirectionSchema }),
  z.object({ steelWeight: sorterDirectionSchema }),
  z.object({ deliveryDestination: sorterDirectionSchema }),
])
export type MillsheetsSorter = z.infer<typeof millsheetsSorterSchema>

export const millsheetSearchConditionSchema = z.object({
  filter: millsheetsFilterSchema.optional(),
  sorter: millsheetsSorterSchema.array().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
})
export type MillsheetSearchCondition = z.infer<typeof millsheetSearchConditionSchema>
